import { OrgManager, OrgManagerRole, OrgManagerStatus } from '@uplift/api';
import { SelectOption } from '@uplift/ui-v2';
import { capitalizeFirstCharacter } from '@uplift/utils';

export const adminOption: SelectOption = {
  label: capitalizeFirstCharacter(OrgManagerRole.admin),
  value: OrgManagerRole.admin,
  detailLabel: 'Can invite staff and make student referrals',
};

export const staffOption: SelectOption = {
  label: capitalizeFirstCharacter(OrgManagerRole.staff),
  value: OrgManagerRole.staff,
  detailLabel: 'Can make student referrals',
};

export const managerRoleOptions: SelectOption[] = [ adminOption, staffOption ];
export const adminSpecificManagerRoleOptions: SelectOption[] = [ staffOption ];

export const transformDataForSelectOptions = (managers?: OrgManager[]) => {
  return managers
    ?.filter(manager => manager?.role !== OrgManagerRole.owner && manager?.status === OrgManagerStatus.active)
    .map(manager => {
      const { firstName, lastName, id } = manager.user;
      const label = `${firstName} ${lastName}`;
      const detailLabel = manager.profile?.title || '';
      const value = id;

      return { label, detailLabel, value };
    }) ?? [];
};
